// Long Distance Letter
const longDistanceLetter = {
  id: 2,
  dateArchived: '2024-04-01',
  title: 'Long Distance Letter',
  isNew: false,
  letterContent: {
    text: `To be honest, I've never missed a person this much in my entire life. There's something about the distance that makes even the smallest things feel heavy — not hearing your voice at the end of the day, not being able to just be in the same room as you. But through all of it, I've never been more sure of anything. In every single lifetime, I choose you.`,
    image: '',
    greeting: 'My Dearest Reegan,',
    closing: 'With all my love,',
    signature: 'Alex'
  }
};

export default longDistanceLetter;
